import { type ApiClient, createApiClient } from "@kalaporssi/client";
import { playerTokenStorageKey } from "@kalaporssi/shared";
import { getHostToken } from "./auth";
import { getConfig } from "./config";

export interface PlayerSession {
  playerId: string;
  playerToken: string;
}

export function readPlayerSession(code: string): PlayerSession | null {
  try {
    const raw = localStorage.getItem(playerTokenStorageKey(code));
    if (!raw) return null;
    // Stored as JSON {playerId, playerToken}; a bare token string is accepted too.
    return raw.startsWith("{") ? (JSON.parse(raw) as PlayerSession) : { playerId: "", playerToken: raw };
  } catch {
    return null;
  }
}

export function savePlayerSession(code: string, s: PlayerSession) {
  try {
    localStorage.setItem(playerTokenStorageKey(code), JSON.stringify(s));
  } catch {
    // private mode: the token lives only in memory for this tab
    memory.set(code, s);
  }
}

const memory = new Map<string, PlayerSession>();

let client: ApiClient | null = null;

export function api(): ApiClient {
  client ??= createApiClient({
    baseUrl: getConfig().apiBaseUrl,
    getHostToken,
    getPlayerToken: (code) => readPlayerSession(code)?.playerToken ?? memory.get(code)?.playerToken ?? null,
  });
  return client;
}
